import React from 'react';
import './PedidosDisplayer.scss';

import PedidoCard from './components/PedidoCard/PedidoCard';
import { Pedido } from '../../../types';

interface PedidosDisplayerProps {
    pedidos: Pedido[];
    setPedidos: any;
}

const PedidosDisplayer: React.FC<PedidosDisplayerProps> = ({ pedidos, setPedidos }) => {

    return (
        <>
            <div className="delivery-pedidos-grid">
                {pedidos?.map((pedido, index) => (
                        <PedidoCard
                        key={pedido.pedido_id}
                            pedido={pedido}
                            index={index}
                            pedidos={pedidos}
                            setPedidos={setPedidos}
                        />
                ))}
            </div>

        </>
    );
};

export default PedidosDisplayer;
